import type {SearchState} from '@/types/models/creator-crm/creatorCrm';
import type {FiltersGroup} from '@/types/models/creator-crm/filter';
import type {
  FilterIds,
  FiltersGroupId,
} from '@/types/models/creator-crm/filterId';
import type {
  SegmentFilters,
  SegmentMultiPlatformFilter,
} from '@/types/models/segments/segment';
import {mapToMultiplatformFilter} from '@/api/fetchers/creators/search-crm/utils';

type FilterGroups = Record<FiltersGroupId, FiltersGroup<FilterIds>>;

/**
 * Converts current CRM filter state to segment filter format (camelCase).
 * Used for comparing with saved segments and for create/update request payloads
 * (fetcher converts to snake_case for API).
 * searchState is mapped to the segment: type 'bio' → profile.bio, 'content' →
 * profile.captions, 'all' → compound, 'name' → compound_name, 'handle' → handle
 * (via mapToMultiplatformFilter).
 */
// eslint-disable-next-line import/prefer-default-export
export function convertFiltersToSegment(
  filterGroups: FilterGroups,
  searchState?: SearchState
): SegmentFilters {
  const multiPlatformFilter = mapToMultiplatformFilter(
    filterGroups,
    searchState as SearchState | undefined
  );
  return {
    type: 'MultiPlatformFilter',
    ...multiPlatformFilter,
  } as SegmentMultiPlatformFilter;
}
